import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';

import { useJurisdictions as useJurisdictionsHook } from '#client/hooks/useJurisdictions';

import { DBA_ALLOWED_STATES } from '../constants/dbaEntity';
import { INITIAL_REPORT_ALLOWED_STATES } from '../constants/initialReport';

export const useJurisdictionsBusinessEntity = () => {
  const { businessEntityUuid } = useBusinessEntity();
  const { data, error, loading } = useJurisdictionsHook(businessEntityUuid);

  // Extract jurisdiction codes from the fetched data
  const jurisdictionCodes = data?.map((jurisdiction) => jurisdiction.jurisdictionCode) || [];

  return {
    jurisdictionCodes,
    loading,
    error,
  };
};

export const useJurisdictions = (serviceCode) => {
  const { jurisdictionCodes, loading, error } = useJurisdictionsBusinessEntity();

  const getJurisdictions = () => {
    switch (serviceCode) {
      case 'standard_good_standing':
        return jurisdictionCodes;
      case 'dba_entity':
        return DBA_ALLOWED_STATES;
      case 'wfg_initial_report':
        return INITIAL_REPORT_ALLOWED_STATES;
      default:
        return [];
    }
  };

  return {
    jurisdictions: getJurisdictions(),
    loading,
    error,
  };
};
